import React from 'react';
import { Handle, NodeProps, Position } from '@xyflow/react';

export type CompanyNodeData = {
  ticker: string;
  companyId?: string;
  companyName?: string;
};

export type ThemeNodeData = {
  theme: string;
  terms: string[];
  context: string;
  sentiment: 'Positivo' | 'Negativo' | 'Sem sentimento';
  gl?: string | null;
  hl?: string | null;
  ceid?: string | null;
  localidadeLabel?: string | null;
};

export const CompanyNode: React.FC<NodeProps> = ({ data }) => {
  const nodeData = data as CompanyNodeData;

  return (
    <div className="min-w-[180px] rounded-xl border border-blue-200 bg-white px-4 py-3 shadow-sm">
      <Handle type="target" id="target-left" position={Position.Left} className="!bg-blue-700" />
      <Handle type="target" id="target-right" position={Position.Right} className="!bg-blue-700" />
      <Handle type="target" id="target-top" position={Position.Top} className="!bg-blue-700" />
      <Handle type="target" id="target-bottom" position={Position.Bottom} className="!bg-blue-700" />

      <Handle type="source" id="source-left" position={Position.Left} className="!bg-blue-700" />
      <Handle type="source" id="source-right" position={Position.Right} className="!bg-blue-700" />
      <Handle type="source" id="source-top" position={Position.Top} className="!bg-blue-700" />
      <Handle type="source" id="source-bottom" position={Position.Bottom} className="!bg-blue-700" />
      <div className="flex items-center gap-2">
        <span className="text-blue-700" aria-hidden="true">
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M3 21h18" />
            <path d="M5 21V8l7-4 7 4v13" />
            <path d="M9 10h2" />
            <path d="M13 10h2" />
          </svg>
        </span>
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Empresa</p>
          <p className="text-sm font-bold text-blue-900">{nodeData.ticker}</p>
          {nodeData.companyName && (
            <p className="max-w-[180px] truncate text-[11px] text-gray-500">{nodeData.companyName}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export const ThemeNode: React.FC<NodeProps> = ({ data }) => {
  const nodeData = data as ThemeNodeData;

  return (
    <div className="min-w-[220px] rounded-xl border border-blue-700 bg-blue-900 px-4 py-3 shadow-md">
      <Handle type="target" id="target-left" position={Position.Left} className="!bg-blue-300" />
      <Handle type="target" id="target-right" position={Position.Right} className="!bg-blue-300" />
      <Handle type="target" id="target-top" position={Position.Top} className="!bg-blue-300" />
      <Handle type="target" id="target-bottom" position={Position.Bottom} className="!bg-blue-300" />

      <Handle type="source" id="source-left" position={Position.Left} className="!bg-green-400" />
      <Handle type="source" id="source-right" position={Position.Right} className="!bg-green-400" />
      <Handle type="source" id="source-top" position={Position.Top} className="!bg-green-400" />
      <Handle type="source" id="source-bottom" position={Position.Bottom} className="!bg-green-400" />
      <p className="text-sm font-semibold text-white">{nodeData.theme}</p>
      <p className="mt-1 text-xs text-blue-100">
        Termos: {nodeData.terms.length ? nodeData.terms.join(', ') : 'Não definidos'}
      </p>
      <p className="mt-1 text-[11px] text-blue-200">
        {nodeData.context?.trim() ? 'Contexto definido' : 'Sem contexto'}
      </p>
      <p className="mt-1 text-[11px] text-blue-200">
        Localidade de busca: {nodeData.localidadeLabel?.trim() ? nodeData.localidadeLabel : 'Brasil (padrão)'}
      </p>
    </div>
  );
};
